var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpenSection(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.50002 2.46094C8.50002 2.1848 8.27616 1.96094 8.00002 1.96094C7.72387 1.96094 7.50002 2.1848 7.50002 2.46094V7.5L2.46216 7.5C2.18602 7.5 1.96216 7.72386 1.96216 8C1.96216 8.27614 2.18602 8.5 2.46216 8.5L7.50002 8.5L7.50002 13.5379C7.50002 13.814 7.72387 14.0379 8.00002 14.0379C8.27616 14.0379 8.50002 13.814 8.50002 13.5379V8.5L13.5391 8.5C13.8152 8.5 14.0391 8.27614 14.0391 8C14.0391 7.72386 13.8152 7.5 13.5391 7.5L8.50002 7.5V2.46094Z",
    fill: "#202635"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenSection);
export default __webpack_public_path__ + "static/media/open-section.bb2a5c9e.svg";
export { ForwardRef as ReactComponent };